var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.haveItems
    ? _c(
        "div",
        _vm._l(_vm.$store.state.ui.toolstripItems, function (item, index) {
          return _c("toolstrip-item", {
            key: index,
            attrs: { "content-button-config": item },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }